import * as React from "react";

// Config
// import { exportCSVFile } from "@/config/csvConfig";

// CSS
import "@/styles/components/systemCardStyles.css";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledBlogCard } from "@/styles/mui/globalStyles";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
// import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";

// Mui Icon
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import DownloadIcon from "@mui/icons-material/Download";
import BlockIcon from "@mui/icons-material/Block";

// import DownloadIcon from "@mui/icons-material/Download";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Navigate
import { useNavigate } from "react-router-dom";

// fetch
import { exportCSVFile } from "@/config/csvConfig";

import { importMonthlyTarget, getAllShopTargetList } from "@/fetch/fetchTarget";
import _ from "lodash";

export default function SystemCard(props) {
  const { month, year, workExist, fetchAll, setSnackOpen, setSnackMessage } =
    props;

  // Navigate
  const navigate = useNavigate();
  const fileReader = new FileReader();

  const datetime = moment(`${year}-${month}-01`).format("YYYY-MM-DD");
  const dateHeader = `${year}-${month}`;

  const exportWorkLocation = async () => {
    const headers = {
      id: "id",
      work_shortcode: "work_shortcode",
      work_name: "work_name",
      work_district: "work_district",
      work_address: "work_address",
      work_telephone: "work_telephone",
      target_total_amount: "target_total_amount",
      street: "street",
      is_active: "is_active",
    };
    const { data: targetList } = await getAllShopTargetList(datetime);
    const csvData = _.map(targetList, (data) => {
      return {
        id: data.id,
        work_shortcode: `"${data.work_shortcode}"`,
        work_name: `"${data.work_name}"`,
        work_district: `"${data.work_district}"`,
        work_address: `"${data.work_address}"`,
        work_telephone: `"${data.work_telephone}"`,
        target_total_amount: `"${data.target_total_amount}"`,
        street: `"${data.street}"`,
        is_active: data.is_active,
      };
    });
    exportCSVFile(headers, csvData, `Work Location List - ${datetime}`);
  };

  const handleOnChange = (e, settingType, systemType) => {
    e.preventDefault();

    const file = e.target.files[0];

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs"
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].length > 0) {
            var obj = {};
            var currentline = match(lines[i]);

            // Columns
            for (var j = 0; j < headers.length; j++) {
              if (currentline[j] !== "" && currentline[j] !== undefined) {
                if (headers[j] === "target_total_amount") {
                  if (isNaN(parseInt(currentline[j]))) {
                    setSnackMessage(
                      "target_total_amount is not a valid number value"
                    );
                    setSnackOpen(true);
                    setTimeout(() => {
                      setSnackOpen(false);
                    }, 1500);
                    return false;
                  } else {
                    obj[headers[j]] = currentline[j];
                  }
                } else {
                  obj[headers[j]] = currentline[j];
                }
              }
            }
            result.push(obj);
          }
        }

        // Output
        if (settingType === "work" && systemType === "create") {
          await importMonthlyTarget(datetime, result).then((data) => {
            if (data && data.results) {
              setSnackMessage(`上傳成功`);
            } else {
              setSnackMessage(`上傳失敗`);
            }
            setSnackOpen(true);
            setTimeout(() => {
              setSnackOpen(false);
            }, 1500);
          });
        }

        fetchAll();
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };

  return (
    <StyledBlogCard onClick={props.onClick}>
      <div className="systemContainer">
        <span className="shapeLeft" />
        <div className="systemIconContainer">
          <FolderOpenIcon sx={{ fontSize: 24, zIndex: 11 }} />
        </div>
        <span
          className="filter"
          style={{
            backgroundColor:
              moment(datetime).format("YYYY-MM") === moment().format("YYYY-MM")
                ? "#1976d2"
                : moment(datetime).format("YYYY-MM") <
                  moment().format("YYYY-MM")
                ? "grey"
                : moment(datetime).format("YYYY-MM") >
                  moment().format("YYYY-MM")
                ? "#0a9c75"
                : "#ffffff",
          }}
        />
        <span className="systemTopBox" />
      </div>
      <div className="systemContentContainer">
        <Typography
          variant="caption"
          noWrap
          component="div"
          sx={{
            margin: "0px 6px 8px",
            lineHeight: "1.5",
            fontSize: "1rem",
            fontWeight: "400",
          }}
        >
          {month}月
        </Typography>
        <div className="divider" />
        <Stack
          direction="row"
          // divider={<Divider orientation="vertical" flexItem />}
          spacing={2}
          sx={{ marginTop: "20px" }}
        >
          <div className="stackUploadContainer">
            <Typography variant="caption" noWrap component="div">
              店鋪
            </Typography>
          </div>
          {/* <div className="stackUploadContainer">
            <Typography variant="caption" noWrap component="div">
              佣金
            </Typography>
          </div> */}
        </Stack>
        <Stack
          direction="row"
          // divider={<Divider orientation="vertical" flexItem />}
          spacing={2}
        >
          <div className="stackUploadContainer">
            {/* SHOP */}
            {workExist &&
            moment(datetime).isSameOrAfter(moment().startOf("month")) ? (
              <IconButton
                onClick={() =>
                  navigate(`/monthlySetting/work/${dateHeader}`, {
                    state: { mode: "edit" },
                  })
                }
              >
                <MoreHorizIcon />
              </IconButton>
            ) : moment(datetime).isBefore(moment().startOf("month")) ? (
              <IconButton
                component="label"
                onClick={() => exportWorkLocation()}
              >
                <DownloadIcon />
              </IconButton>
            ) : (
              <IconButton component="label">
                <DriveFolderUploadIcon />
                <input
                  hidden
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".csv"}
                  onChange={(e) => handleOnChange(e, "work", "create")}
                />
              </IconButton>
            )}
          </div>
          {/* COMMISSION SETTING */}
          {/* <div className="stackUploadContainer">
            {moment(datetime).isSameOrAfter(moment().startOf("month")) ? (
              <IconButton onClick={() => navigate(`/commission`)}>
                <MoreHorizIcon />
              </IconButton>
            ) : (
              <IconButton component="label" disabled>
                <BlockIcon />
              </IconButton>
            )}
          </div> */}
          {/* ROSTER */}
          {/* <div className="stackUploadContainer">
            {rosterExist ? (
              <IconButton
                onClick={() =>
                  navigate(`/systemSetting/roster/${dateHeader}?tab=user`)
                }
              >
                <MoreHorizIcon />
              </IconButton>
            ) : (
              <IconButton component="label">
                <SystemSettingShiftMenu
                  {...{
                    ...props,
                    year,
                    month,
                    propSnackMessage,
                    handleOnChange,
                    selectedDatetime: datetime,
                  }}
                />
              </IconButton>
            )}
          </div> */}
        </Stack>
      </div>
    </StyledBlogCard>
  );
}
